import React, { useState, useEffect, useCallback } from "react";
import Header from "../Header";
import {
  BiCheckCircle,
  BiMobileAlt,
  BiEnvelope,
  BiSolidCheckCircle,
  BiCalendarAlt,
  BiMap,
} from "react-icons/bi";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import carReportimage from "../assets/car-condition-report.png";
// import car from '../assets/Car-Icon.png';
import customerSupportImage from "../assets/customer-subport.png";
import carGiftImg from "../assets/car-gift.png";
import faceImage from "../assets/happy-smlie.png";
import faceImg from "../assets/customer-gallery.png";
import faceImg2 from "../assets/customer-gallery2.png";
import faceImg3 from "../assets/customer-gallery3.png";
import { Helmet } from "react-helmet-async";
import CarCondition from "../CarCondition";
// import AddedGST from '../AddedGST';
import { IoWarningOutline } from "react-icons/io5";
import HTTP_BASE_URL from "../../constants/HttpConstants";
import Loading from "../Loading";
import Footer from "../Footer";
import { IoPersonCircleOutline } from "react-icons/io5";
import TruncatedView from "../TruncatedView";
import BillingGst from "../BillingGst";
import BookingLocations from "../BookingLocations";
import CarDetailsForm from "../CarDetails";
import SenderReceiverDetails from "../SenderReceiverDetails";
import AmountHistory from "../AmountHistory";
import QuotationRequestForm from "../QuotationRequestForm";
import useCustomMethods from "../../hooks/useCustomMethods";
import {
  getDriverActivity,
  getBookingdetailsApi,
} from "../../services/bookingApi";

const Home = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Extract "id" from the URL
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingComp, setIsLoadingComp] = useState(false);
  //eslint-disable-next-line
  const [condtionModel, setCondtionModel] = useState(false);
  const [deliveryCondtionModel, setDeliveryCondtionModel] = useState(false);

  // const [payModal, setPayModal] = useState(false)

  const [quotationModal, setQuotationModal] = useState(false);
  const [bookingDetails, setBookingDetails] = useState(null);
  const [pickupCondition, setPickupCondition] = useState(null);
  const [deliveryCondition, setDeliveryCondition] = useState(null);
  const [billingModal, setBillingModal] = useState(false);
  const [bookingLocation, setBookingLocation] = useState(false);
  const [CarDetails, setCarDetails] = useState(false);
  const [senderReceiver, setSenderReceiver] = useState(false);
  const [addressType1List, setAddressType1List] = useState([]);
  const [addressType2List, setAddressType2List] = useState([]);
  const [addressType3List, setAddressType3List] = useState([]);
  const [bookingStatus, setBookingStatus] = useState([]);
  const [transitDetails, getTransitDetails] = useState(false);
  const [quoteStatus, setQuoteStatus] = useState([]);
  const [amountHistory, setAmountHistory] = useState(false);
  const customertoken = localStorage.getItem("customertoken");

  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [faceImage, faceImg, faceImg2, faceImg3];
  const [trackData, setTrackData] = useState([]);
  const { formatDateTime, firstLetterUpperCase } = useCustomMethods();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // Change image every 3 seconds
    // getDriverActivityApi();
    return () => clearInterval(interval); // Cleanup interval on component unmount
  });

  const getDriverActivityApi = () => {
    const formData = new FormData();
    formData.append("bookingid", id);
    getDriverActivity(formData)
      .then((res) => {
        if (res.data.code === 0) {
          setTrackData(res.data.data);
        }
      })
      .catch(() => {
        toast.warn("The server did not respond. Try again after some time");
      });
  };

  const BookingdetailsApi = () => {
    // setIsLoadingComp(true);
    const formdata = new FormData();
    formdata.append("id", id);
    getBookingdetailsApi(formdata).then((res) => {
      if (res.code === 0) {
        setPickupCondition(res.data.pickup_condition);
        setDeliveryCondition(res.data.delivery_report);
        // setIsLoadingComp(false);
      }
    });
  };

  const getBookDetails = useCallback(async () => {
    const myHeaders = new Headers();
    myHeaders.append("access-token", "508b1430-68f0-4b2f-9003-3c2a0eb2a54a");
    myHeaders.append("customertoken", customertoken);

    const formdata = new FormData();
    formdata.append("id", id);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    try {
      await fetch(HTTP_BASE_URL + "getBookingdetails", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.code === 0) {
            setBookingDetails(result.data.booking_details);
            setPickupCondition(result.data.pickup_condition);
            setDeliveryCondition(result.data.delivery_report);
          } else {
            // Step 1: Clear storage
            localStorage.clear(); // or sessionStorage.clear();
            // Step 2: Redirect to login or home page
            navigate("/", { replace: true });
            // Step 3: Prevent going back to the previous page
            window.history.pushState(null, "", window.location.href);
            window.onpopstate = () => {
              window.history.pushState(null, "", window.location.href);
            };
          }
        });
    } catch (error) {
      // setError(error); // Store any errors in the state
      console.error("Error:", error);
    }
  }, [id, customertoken, navigate]);

  const getTransitInsurance = useCallback(async () => {
    const fullData = new FormData();
    fullData.append("bookingid", id);
    try {
      await fetch(HTTP_BASE_URL + "getTransitInsurance", {
        method: "post",
        headers: {
          "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
          customertoken: customertoken,
        },
        body: fullData,
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.code === 0) {
            getTransitDetails(true);
          }
        });
    } catch (error) {
      console.error(error);
    }
  }, [id, customertoken]);

  const getEnquiryDetails = useCallback(async () => {
    const fullData = new FormData();
    fullData.append("id", id);
    try {
      await fetch(HTTP_BASE_URL + "getEnquiryDetails", {
        method: "post",
        headers: {
          "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
          customertoken: customertoken,
        },
        body: fullData,
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.code === 0) {
            setBookingStatus(result.data);
          } else {
            navigate("/");
          }
        });
    } catch (error) {
      // setError(error); // Store any errors in the state
      console.error("Error:", error);
    }
  }, [id, customertoken, navigate]);

  const getAddressList = useCallback(async () => {
    const fullData = new FormData();
    fullData.append("bookingid", id);
    try {
      await fetch(HTTP_BASE_URL + "getAddressList", {
        method: "post",
        headers: {
          "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
          customertoken: customertoken,
        },
        body: fullData,
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.code === 0) {
            // console.log(result)
            const addressType1 = result.data.filter(
              (item) => item.address_type === 1
            );
            const addressType2 = result.data.filter(
              (item) => item.address_type === 2
            );
            const addressType3 = result.data.filter(
              (item) => item.address_type === 3
            );

            // console.log('addresslist', result.data)
            setAddressType1List(addressType1);
            setAddressType2List(addressType2);
            setAddressType3List(addressType3);
          } else {
            navigate("/");
          }
        });
    } catch (error) {
      // setError(error); // Store any errors in the state
      console.error("Error:", error);
    }
  }, [id, customertoken, navigate]);

  const getBalance = useCallback(async () => {
    const formData = new FormData();
    formData.append("id", id);
    try {
      await fetch(HTTP_BASE_URL + "getBalance", {
        method: "post",
        headers: {
          "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
          customertoken: customertoken,
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.code === 0) {
            setQuoteStatus(result.data);
            // console.log(result.data);
          } else {
            navigate("/");
          }
        });
    } catch (error) {
      console.error(error);
    }
  }, [id, customertoken, navigate]);

  // quote and invoice amount show

  const invoice = Number(quoteStatus?.invoice) || 0;
  const invoiceExists = invoice > 0; // If invoice exists, show invoiced amount
  const balance = quoteStatus?.balance ?? 0;
  const paid = quoteStatus?.paid ?? 0;

  // Set the displayed amount and text
  const amountLabel = invoiceExists ? "Invoiced Amount" : "Quoted Amount";
  const amountValue = invoiceExists ? quoteStatus?.invoice : quoteStatus?.quote;

  // Determine if the payment button should be disabled
  const isPayDisabled = balance <= 0;

  const tokenExpiry = useCallback(() => {
    if (!customertoken) {
      // console.log('tokenExpiry')
      // Step 1: Clear storage
      localStorage.clear(); // or sessionStorage.clear();
      // Step 2: Redirect to login or home page
      navigate("/", { replace: true });
      // Step 3: Prevent going back to the previous page
      window.history.pushState(null, "", window.location.href);
      window.onpopstate = () => {
        window.history.pushState(null, "", window.location.href);
      };
    }
  }, [customertoken, navigate]);

  useEffect(() => {
    setIsLoading(true);
    getBookDetails();
    getAddressList();
    getEnquiryDetails();
    getTransitInsurance();
    getBalance();
    tokenExpiry();
    getDriverActivityApi();
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1200);
    return () => clearTimeout(timer);
  }, [
    getBookDetails,
    getAddressList,
    getEnquiryDetails,
    getTransitInsurance,
    tokenExpiry,
    getBalance,
  ]);

  useEffect(() => {
    if (condtionModel || deliveryCondtionModel) BookingdetailsApi();
  }, [condtionModel, deliveryCondtionModel]);

  useEffect(() => {
    if (
      bookingStatus?.booking_status === 1 ||
      bookingStatus?.booking_status === 0
    ) {
      setQuotationModal(true);
    }
  }, [bookingStatus]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <Helmet>
        <title>#{id}</title>
      </Helmet>
      <Header />
      <ToastContainer position="top-center" autoClose={1000} />
      {condtionModel && (
        <CarCondition
          title="Pickup"
          condition={pickupCondition}
          close={setCondtionModel}
          loading={isLoadingComp}
          setLoading={setIsLoadingComp}
        />
      )}
      {deliveryCondtionModel && (
        <CarCondition
          title="Delivery"
          condition={deliveryCondition}
          close={setDeliveryCondtionModel}
          loading={isLoadingComp}
          setLoading={setIsLoadingComp}
        />
      )}
      {/* {payModal && (< AddedGST close={setPayModal} />)} */}

      {quotationModal && (
        <QuotationRequestForm id={id} close={setQuotationModal} />
      )}

      {billingModal && <BillingGst close={setBillingModal} id={id} />}
      {bookingLocation && (
        <BookingLocations close={setBookingLocation} id={id} />
      )}
      {CarDetails && <CarDetailsForm close={setCarDetails} id={id} />}
      {senderReceiver && (
        <SenderReceiverDetails close={setSenderReceiver} id={id} />
      )}
      {amountHistory && <AmountHistory close={setAmountHistory} id={id} />}

      <div className="container-fluid booking-section">
        <div className="container">
          <div className="row booking-row pt-lg-4 pb-lg-5">
            <div className="col d-md-none col-lg-1 "></div>
            <div className="col col-md-7 col-lg-6 col-12 p-0 ">
              <div className="bookingDiv mb-3">
                {bookingStatus && (
                  <div className="booking-inline-row no-wrap">
                    <div className="status-box">
                      {bookingStatus?.booking_status === "" ? (
                        <IoWarningOutline style={{ color: "#D7000C" }} />
                      ) : (
                        ""
                      )}
                      {bookingStatus?.booking_status === 0 ? (
                        <BiCheckCircle style={{ color: "#000" }} />
                      ) : (
                        ""
                      )}
                      {bookingStatus?.booking_status === 1 ? (
                        <BiCheckCircle style={{ color: "#000" }} />
                      ) : (
                        ""
                      )}
                      {bookingStatus?.booking_status === 2 ? (
                        <BiCheckCircle style={{ color: "orange" }} />
                      ) : (
                        ""
                      )}
                      {bookingStatus?.booking_status === 3 ? (
                        <BiCheckCircle style={{ color: "orange" }} />
                      ) : (
                        ""
                      )}
                      {bookingStatus?.booking_status === 4 ? (
                        <BiCheckCircle style={{ color: "orange" }} />
                      ) : (
                        ""
                      )}
                      {bookingStatus?.booking_status === 5 ? (
                        <BiCheckCircle style={{ color: "#1677a3" }} />
                      ) : (
                        ""
                      )}
                      {bookingStatus?.booking_status === 6 ? (
                        <BiCheckCircle style={{ color: "#01c3c6" }} />
                      ) : (
                        ""
                      )}
                      {bookingStatus?.booking_status === 7 ? (
                        <BiCheckCircle style={{ color: "#01c3c6" }} />
                      ) : (
                        ""
                      )}
                      {bookingStatus?.booking_status === 8 ? (
                        <BiCheckCircle style={{ color: "#8A2BE2" }} />
                      ) : (
                        ""
                      )}
                      {bookingStatus?.booking_status === 9 ? (
                        <BiCheckCircle style={{ color: "#8A2BE2" }} />
                      ) : (
                        ""
                      )}
                      {bookingStatus?.booking_status === 10 ? (
                        <BiCheckCircle style={{ color: "#FF15BD" }} />
                      ) : (
                        ""
                      )}
                      {bookingStatus?.booking_status === 11 ? (
                        <BiCheckCircle style={{ color: "#D1C31C" }} />
                      ) : (
                        ""
                      )}
                      {bookingStatus?.booking_status === 12 ? (
                        <BiCheckCircle style={{ color: "#3D29AF" }} />
                      ) : (
                        ""
                      )}
                      {bookingStatus?.booking_status === 13 ? (
                        <BiCheckCircle style={{ color: "#AF388E" }} />
                      ) : (
                        ""
                      )}
                      {bookingStatus?.booking_status === 14 ? (
                        <BiCheckCircle style={{ color: "#717D9C" }} />
                      ) : (
                        ""
                      )}
                      {bookingStatus?.booking_status === 15 ? (
                        <BiCheckCircle style={{ color: "#2FCC30" }} />
                      ) : (
                        ""
                      )}
                      {bookingStatus?.booking_status === 16 ? (
                        <BiCheckCircle style={{ color: "#ff6347" }} />
                      ) : (
                        ""
                      )}
                      {bookingStatus?.booking_status === 17 ? (
                        <BiCheckCircle style={{ color: "#16825a" }} />
                      ) : (
                        ""
                      )}
                      {bookingStatus?.booking_status === 18 ? (
                        <BiCheckCircle style={{ color: "#ff6347" }} />
                      ) : (
                        ""
                      )}
                    </div>
                    {bookingStatus?.booking_status === "" ? (
                      <div>
                        <p className="main-heading red">
                          Your Booking is incomplete !
                        </p>
                        <p className="text-para">
                          Please fill all the details to proceed further.
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    {bookingStatus?.booking_status === 0 ? (
                      <div>
                        <p className="main-heading" style={{ color: "#000" }}>
                          Lead !
                        </p>
                        <p className="text-para">
                          Please fill all the details to proceed further.
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    {bookingStatus?.booking_status === 1 ? (
                      <div>
                        <p className="main-heading" style={{ color: "#000" }}>
                          Lead !
                        </p>
                        <p className="text-para">
                          Please fill all the details to proceed further.
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    {bookingStatus?.booking_status === 2 ? (
                      <div>
                        <p className="main-heading" style={{ color: "orange" }}>
                          Your Quotation Request Made Easy !
                        </p>
                        <p className="text-para">
                          We'll get back to you soon with our best quote.
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    {bookingStatus?.booking_status === 3 ? (
                      <div>
                        <p className="main-heading" style={{ color: "orange" }}>
                          You have received the quote !
                        </p>
                        <p className="text-para">
                          Please pay at least 10% of your quote to proceed.
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    {bookingStatus?.booking_status === 4 ? (
                      <div>
                        <p className="main-heading" style={{ color: "orange" }}>
                          Your quotation has been revised !
                        </p>
                        <p className="text-para">
                          Please pay at least 10% of your quote to proceed.
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    {bookingStatus?.booking_status === 5 ? (
                      <div>
                        <p
                          className="main-heading"
                          style={{ color: "#1677a3" }}
                        >
                          Your Booking confirmed !
                        </p>
                        <p className="text-para">
                          Your car pickup and delivery booking is successfully
                          confirmed.
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    {bookingStatus?.booking_status === 6 ? (
                      <div>
                        <p
                          className="main-heading"
                          style={{ color: "#01c3c6" }}
                        >
                          Pickup Scheduled !
                        </p>
                        <p className="text-para">
                          Your car pickup is confirmed and scheduled.
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    {bookingStatus?.booking_status === 7 ? (
                      <div>
                        <p
                          className="main-heading"
                          style={{ color: "#01c3c6" }}
                        >
                          Pickup Completed !
                        </p>
                        <p className="text-para">
                          Your car pickup has been successfully completed.
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    {bookingStatus?.booking_status === 8 ? (
                      <div>
                        <p
                          className="main-heading"
                          style={{ color: "#8A2BE2" }}
                        >
                          Truck Assigned !
                        </p>
                        <p className="text-para">
                          A truck has been assigned for your car pickup and
                          delivery.
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    {bookingStatus?.booking_status === 9 ? (
                      <div>
                        <p
                          className="main-heading"
                          style={{ color: "#8A2BE2" }}
                        >
                          Car Loaded !
                        </p>
                        <p className="text-para">
                          Your car has been successfully loaded for delivery.
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    {bookingStatus?.booking_status === 10 ? (
                      <div>
                        <p
                          className="main-heading"
                          style={{ color: "#FF15BD" }}
                        >
                          In Transit !
                        </p>
                        <p className="text-para">
                          Your car is currently in transit and on its way.
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    {bookingStatus?.booking_status === 11 ? (
                      <div>
                        <p
                          className="main-heading"
                          style={{ color: "#D1C31C" }}
                        >
                          Transit On Hold !
                        </p>
                        <p className="text-para">
                          Your car's transit has been temporarily paused.
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    {bookingStatus?.booking_status === 12 ? (
                      <div>
                        <p
                          className="main-heading"
                          style={{ color: "#3D29AF" }}
                        >
                          Final Hub Reached !
                        </p>
                        <p className="text-para">
                          Your car has successfully reached its final hub.
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    {bookingStatus?.booking_status === 13 ? (
                      <div>
                        <p
                          className="main-heading"
                          style={{ color: "#AF388E" }}
                        >
                          Delivery Scheduled !
                        </p>
                        <p className="text-para">
                          Your car delivery has been scheduled and is on track.
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    {bookingStatus?.booking_status === 14 ? (
                      <div>
                        <p
                          className="main-heading"
                          style={{ color: "#717D9C" }}
                        >
                          Delivery On Hold !
                        </p>
                        <p className="text-para">
                          Your car delivery has been temporarily paused.
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    {bookingStatus?.booking_status === 15 ? (
                      <div>
                        <p
                          className="main-heading"
                          style={{ color: "#2FCC30" }}
                        >
                          Delivered !
                        </p>
                        <p className="text-para">
                          Your car has been successfully delivered.
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    {bookingStatus?.booking_status === 16 ? (
                      <div>
                        <p
                          className="main-heading"
                          style={{ color: "#ff6347" }}
                        >
                          Cancelled !
                        </p>
                        <p className="text-para">
                          Your car pickup or delivery has been cancelled.
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    {bookingStatus?.booking_status === 17 ? (
                      <div>
                        <p
                          className="main-heading"
                          style={{ color: "#16825a" }}
                        >
                          Completed !
                        </p>
                        <p className="text-para">
                          Your car pickup and delivery has been successfully
                          completed.
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    {bookingStatus?.booking_status === 18 ? (
                      <div>
                        <p
                          className="main-heading"
                          style={{ color: "#ff6347" }}
                        >
                          Lead Closed !
                        </p>
                        <p className="text-para">
                          This lead has been successfully closed and requires no
                          further action.
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                )}

                <div className="booking-inline-row">
                  {/* <button className='text-span' onClick={() => setShowModel(true)}>Edit</button> */}
                  <div className="col col-md-7 col-6 p-right">
                    <div>
                      <div className="text-para">
                        Sender Details
                        {Array.isArray(addressType1List) &&
                        addressType1List.length > 0 &&
                        addressType1List[0]?.name &&
                        addressType1List[0]?.name !== "null" &&
                        addressType1List[0]?.mobile &&
                        addressType1List[0]?.mobile !== "null" &&
                        addressType1List[0]?.address_line1 &&
                        addressType1List[0]?.address_line1 !== "null" &&
                        addressType1List[0]?.address_line2 &&
                        addressType1List[0]?.address_line2 !== "null" &&
                        addressType1List[0]?.city &&
                        addressType1List[0]?.city !== "null" &&
                        addressType1List[0]?.state &&
                        addressType1List[0]?.state !== "null" &&
                        addressType1List[0]?.country &&
                        addressType1List[0]?.country !== "null" ? (
                          ""
                        ) : (
                          <IoWarningOutline className="red danger" />
                        )}
                        <span
                          className="text-span link-btn add-btn"
                          onClick={() => setSenderReceiver(true)}
                        >
                          {Array.isArray(addressType1List) &&
                          addressType1List.length > 0 &&
                          addressType1List[0]?.name &&
                          addressType1List[0]?.name !== "null" &&
                          addressType1List[0]?.mobile &&
                          addressType1List[0]?.mobile !== "null" &&
                          addressType1List[0]?.address_line1 &&
                          addressType1List[0]?.address_line1 !== "null" &&
                          addressType1List[0]?.address_line2 &&
                          addressType1List[0]?.address_line2 !== "null" &&
                          addressType1List[0]?.city &&
                          addressType1List[0]?.city !== "null" &&
                          addressType1List[0]?.state &&
                          addressType1List[0]?.state !== "null" &&
                          addressType1List[0]?.country &&
                          addressType1List[0]?.country !== "null"
                            ? "Edit"
                            : "Add"}
                        </span>
                      </div>
                      <p className="sub-heading">
                        <IoPersonCircleOutline className="red" />
                        {Array.isArray(addressType1List) &&
                        addressType1List.length > 0 &&
                        addressType1List[0]?.name &&
                        addressType1List[0]?.name !== "null"
                          ? addressType1List[0]?.name
                          : bookingDetails?.name || bookingStatus?.name}
                      </p>
                      <p className="text-para">
                        <BiMobileAlt className="red" />
                        {Array.isArray(addressType1List) &&
                        addressType1List.length > 0 &&
                        addressType1List[0]?.mobile &&
                        addressType1List[0]?.mobile !== "null"
                          ? addressType1List[0]?.mobile
                          : bookingDetails?.mobile || bookingStatus?.mobile}
                        <br />
                        {/* <Link to='#' className='text-span'> Add Secondary Mobile</Link> */}
                        {Array.isArray(addressType1List) &&
                        addressType1List.length > 0 &&
                        addressType1List[0]?.mobile2 &&
                        addressType1List[0]?.mobile2 !== "null" ? (
                          <>
                            {"\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"}
                            {addressType1List[0]?.mobile2}{" "}
                          </>
                        ) : (
                          ""
                        )}
                      </p>
                      <p className="text-para overflow-auto">
                        <BiEnvelope className="red" />
                        {Array.isArray(addressType1List) &&
                        addressType1List.length > 0 &&
                        addressType1List[0]?.email &&
                        addressType1List[0]?.email !== "null"
                          ? addressType1List[0]?.email
                          : bookingDetails?.email}
                      </p>
                      <p className="sub-heading ">
                        {/* <TruncatedView
                          text={
                            Array.isArray(addressType1List) &&
                            addressType1List.length > 0
                              ? ` ${
                                  addressType1List[0]?.address_line1 || ""
                                }, ${
                                  addressType1List[0]?.address_line2 || ""
                                }, ${addressType1List[0]?.city || ""}, ${
                                  addressType1List[0]?.state || ""
                                }, ${addressType1List[0]?.country || ""} ${
                                  addressType1List[0]?.pincode || ""
                                } ${addressType1List[0]?.landmark || ""}`.trim()
                              : ""
                          }
                          maxLength={20}
                        /> */}

                        {Array.isArray(addressType1List) &&
                        addressType1List.length > 0
                          ? ` ${addressType1List[0]?.address_line1 || ""}, ${
                              addressType1List[0]?.address_line2 || ""
                            }, ${addressType1List[0]?.city || ""}, ${
                              addressType1List[0]?.state || ""
                            }, ${addressType1List[0]?.country || ""} ${
                              addressType1List[0]?.pincode || ""
                            } ${addressType1List[0]?.landmark || ""}`.trim()
                          : ""}
                      </p>
                    </div>
                    <div className="mt-4">
                      <div className="text-para">
                        Receiver Details
                        {Array.isArray(addressType2List) &&
                        addressType2List.length > 0 &&
                        addressType2List[0]?.name &&
                        addressType2List[0]?.name !== "null" &&
                        addressType2List[0]?.mobile &&
                        addressType2List[0]?.mobile !== "null" &&
                        addressType2List[0]?.address_line1 &&
                        addressType2List[0]?.address_line1 !== "null" &&
                        addressType2List[0]?.address_line2 &&
                        addressType2List[0]?.address_line2 !== "null" &&
                        addressType2List[0]?.city &&
                        addressType2List[0]?.city !== "null" &&
                        addressType2List[0]?.state &&
                        addressType2List[0]?.state !== "null" &&
                        addressType2List[0]?.country &&
                        addressType2List[0]?.country !== "null" ? (
                          ""
                        ) : (
                          <IoWarningOutline className="red danger" />
                        )}
                        <span
                          className="text-span link-btn add-btn"
                          onClick={() => setSenderReceiver(true)}
                        >
                          {Array.isArray(addressType2List) &&
                          addressType2List.length > 0 &&
                          addressType2List[0]?.name &&
                          addressType2List[0]?.name !== "null" &&
                          addressType2List[0]?.mobile &&
                          addressType2List[0]?.mobile !== "null" &&
                          addressType2List[0]?.address_line1 &&
                          addressType2List[0]?.address_line1 !== "null" &&
                          addressType2List[0]?.address_line2 &&
                          addressType2List[0]?.address_line2 !== "null" &&
                          addressType2List[0]?.city &&
                          addressType2List[0]?.city !== "null" &&
                          addressType2List[0]?.state &&
                          addressType2List[0]?.state !== "null" &&
                          addressType2List[0]?.country &&
                          addressType2List[0]?.country !== "null"
                            ? "Edit"
                            : "Add"}
                        </span>
                      </div>
                      <p className="sub-heading">
                        <IoPersonCircleOutline className="red" />
                        {Array.isArray(addressType2List) &&
                        addressType2List.length > 0 &&
                        addressType2List[0]?.name &&
                        addressType2List[0]?.name !== "null"
                          ? addressType2List[0].name
                          : bookingDetails?.name || bookingStatus?.name}
                      </p>
                      <p className="text-para">
                        <BiMobileAlt className="red" />
                        {Array.isArray(addressType2List) &&
                        addressType2List.length > 0 &&
                        addressType2List[0]?.mobile &&
                        addressType2List[0]?.mobile !== "null"
                          ? addressType2List[0]?.mobile
                          : bookingDetails?.mobile ||
                            bookingStatus?.mobile}{" "}
                        <br />
                        {Array.isArray(addressType2List) &&
                        addressType2List.length > 0 &&
                        addressType2List[0]?.mobile2 &&
                        addressType2List[0]?.mobile2 !== "null" ? (
                          <>
                            {"\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"}
                            {addressType2List[0]?.mobile2}
                          </>
                        ) : (
                          ""
                        )}
                      </p>
                      <p className="sub-heading ">
                        {/* <TruncatedView
                          text={
                            Array.isArray(addressType2List) &&
                            addressType2List.length > 0
                              ? `${addressType2List[0]?.address_line1 || ""}, ${
                                  addressType2List[0]?.address_line2 || ""
                                }, ${addressType2List[0]?.city || ""}, ${
                                  addressType2List[0]?.state || ""
                                }, ${addressType2List[0]?.country || ""} ${
                                  addressType2List[0]?.pincode || ""
                                } ${addressType2List[0]?.landmark || ""}`.trim()
                              : ""
                          }
                          maxLength={20}
                        /> */}
                        {Array.isArray(addressType2List) &&
                        addressType2List.length > 0
                          ? `${addressType2List[0]?.address_line1 || ""}, ${
                              addressType2List[0]?.address_line2 || ""
                            }, ${addressType2List[0]?.city || ""}, ${
                              addressType2List[0]?.state || ""
                            }, ${addressType2List[0]?.country || ""} ${
                              addressType2List[0]?.pincode || ""
                            } ${addressType2List[0]?.landmark || ""}`.trim()
                          : ""}
                      </p>
                    </div>
                  </div>
                  <div className="col col-md-5 col-6 p-left">
                    <div className="text-para">
                      Billing Details
                      {Array.isArray(addressType3List) &&
                      addressType3List.length > 0 &&
                      addressType3List[0]?.address_line1 &&
                      addressType3List[0]?.address_line1 !== "null" &&
                      addressType3List[0]?.address_line2 &&
                      addressType3List[0]?.address_line2 !== "null" &&
                      addressType3List[0]?.city &&
                      addressType3List[0]?.city !== "null" &&
                      addressType3List[0]?.state &&
                      addressType3List[0]?.state !== "null" &&
                      addressType3List[0]?.country &&
                      addressType3List[0]?.country !== "null" ? (
                        ""
                      ) : (
                        <IoWarningOutline className="red danger" />
                      )}
                      <span
                        className="text-span link-btn add-btn"
                        onClick={() => setBillingModal(true)}
                      >
                        {Array.isArray(addressType3List) &&
                        addressType3List.length > 0 &&
                        addressType3List[0]?.address_line1 &&
                        addressType3List[0]?.address_line1 !== "null" &&
                        addressType3List[0]?.address_line2 &&
                        addressType3List[0]?.address_line2 !== "null" &&
                        addressType3List[0]?.city &&
                        addressType3List[0]?.city !== "null" &&
                        addressType3List[0]?.state &&
                        addressType3List[0]?.state !== "null" &&
                        addressType3List[0]?.country &&
                        addressType3List[0]?.country !== "null"
                          ? "Edit"
                          : "Add"}
                      </span>
                    </div>
                    <p className="sub-heading ">
                      {/* <TruncatedView
                        text={
                          Array.isArray(addressType3List) &&
                          addressType3List.length > 0
                            ? `${addressType3List[0]?.address_line1 || ""}, ${
                                addressType3List[0]?.address_line2 || ""
                              }, ${addressType3List[0]?.city || ""}, ${
                                addressType3List[0]?.state || ""
                              }, ${addressType3List[0]?.country || ""} ${
                                addressType3List[0]?.pincode || ""
                              } ${addressType3List[0]?.landmark || ""}`.trim()
                            : ""
                        }
                        maxLength={20}
                      /> */}
                      {Array.isArray(addressType3List) &&
                      addressType3List.length > 0
                        ? `${addressType3List[0]?.address_line1 || ""}, ${
                            addressType3List[0]?.address_line2 || ""
                          }, ${addressType3List[0]?.city || ""}, ${
                            addressType3List[0]?.state || ""
                          }, ${addressType3List[0]?.country || ""} ${
                            addressType3List[0]?.pincode || ""
                          } ${addressType3List[0]?.landmark || ""}`.trim()
                        : ""}
                    </p>
                    <div>
                      <div className="flex sm-d-block">
                        <p className="text-para">GST No:</p>
                        <p className="sub-heading">
                          {bookingDetails
                            ? bookingDetails?.gstno === "null" ||
                              !bookingDetails?.gstno
                              ? ""
                              : bookingDetails?.gstno
                            : ""}
                        </p>
                      </div>
                      <div className="flex sm-d-block">
                        <p className="text-para">Company Name:</p>
                        <p className="sub-heading">
                          {bookingDetails
                            ? bookingDetails?.company_name === "null" ||
                              !bookingDetails?.company_name
                              ? ""
                              : bookingDetails?.company_name
                            : ""}
                        </p>
                      </div>
                      <div className="flex sm-d-block">
                        <p className="text-para">Payment by:</p>
                        <p className="sub-heading">
                          {bookingDetails
                            ? !bookingDetails?.company_payment_type ||
                              bookingDetails?.company_payment_type === "null"
                              ? bookingDetails?.payment_type === 1
                                ? "Self-Payment"
                                : ""
                              : bookingDetails?.company_payment_type === 1
                              ? "To be Paid"
                              : "Company Pay"
                            : bookingDetails?.payment_type === 1
                            ? "Self-Payment"
                            : ""}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="booking-inline-row">
                  <div className="col col-md-7 col-6 p-right">
                    <p className="text-para">
                      Car Details
                      {bookingDetails ? (
                        bookingDetails?.cartype === "null" ||
                        !bookingDetails?.cartype ||
                        bookingDetails?.carcolour === "null" ||
                        !bookingDetails?.carcolour ||
                        bookingDetails?.carno === "null" ||
                        !bookingDetails?.carno ? (
                          <IoWarningOutline className="red danger" />
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                      <span
                        className="text-span link-btn add-btn"
                        onClick={() => setCarDetails(true)}
                      >
                        {bookingDetails
                          ? bookingDetails?.cartype === "null" ||
                            !bookingDetails?.cartype ||
                            bookingDetails?.carcolour === "null" ||
                            !bookingDetails?.carcolour ||
                            bookingDetails?.carno === "null" ||
                            !bookingDetails?.carno
                            ? "Add"
                            : "Edit"
                          : "Add"}
                      </span>
                    </p>
                    <p className="sub-heading ">
                      {bookingDetails
                        ? bookingDetails?.carmake === "null" ||
                          !bookingDetails?.carmake
                          ? "-"
                          : bookingDetails?.carmake
                        : ""}
                      -{" "}
                      {bookingDetails
                        ? bookingDetails?.carmodel === "null" ||
                          !bookingDetails?.carmodel
                          ? "-"
                          : bookingDetails?.carmodel
                        : ""}
                    </p>
                    <p className="text-para black">
                      {bookingDetails
                        ? bookingDetails?.cartype === "null" ||
                          !bookingDetails?.cartype
                          ? "-"
                          : bookingDetails?.cartype
                        : ""}
                      ,{" "}
                      {bookingDetails
                        ? bookingDetails?.carcolour === "null" ||
                          !bookingDetails?.carcolour
                          ? "-"
                          : bookingDetails?.carcolour
                        : ""}
                    </p>
                    <span className="sub-heading sm-d-block">
                      <p className="text-para d-inline">Car No: </p>
                      {bookingDetails
                        ? bookingDetails?.carno === "null" ||
                          !bookingDetails?.carno
                          ? "NA"
                          : bookingDetails?.carno
                        : ""}
                    </span>
                    <span className="sub-heading sm-d-block">
                      <p className="text-para d-inline">Chassis No: </p>
                      {bookingDetails
                        ? bookingDetails?.chasisno === "null" ||
                          !bookingDetails?.chasisno
                          ? "NA"
                          : bookingDetails?.chasisno
                        : ""}
                    </span>
                    <span className="sub-heading sm-d-block">
                      <p className="text-para d-inline">Engine No: </p>
                      {bookingDetails
                        ? bookingDetails?.engineno === "null" ||
                          !bookingDetails?.engineno
                          ? "NA"
                          : bookingDetails?.engineno
                        : ""}
                    </span>
                    {/* <button className='verified-text green'> <BiSolidCheckCircle style={{ width: '15px', height: '15px' }} /> Digitally verified by mParivahan</button> */}
                  </div>
                  <div className="col col-md-5 col-6 p-left">
                    <p className="text-para">
                      Insurance Details:
                      {bookingDetails ? (
                        bookingDetails?.insurance_company === "null" ||
                        !bookingDetails?.company_name ||
                        bookingDetails?.insurance_no === "null" ||
                        !bookingDetails?.insurance_no ? (
                          <IoWarningOutline className="red danger" />
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                      <span
                        className="text-span link-btn add-btn"
                        onClick={() => setCarDetails(true)}
                      >
                        {bookingDetails
                          ? bookingDetails?.insurance_company === "null" ||
                            !bookingDetails?.company_name ||
                            bookingDetails?.insurance_no === "null" ||
                            !bookingDetails?.insurance_no
                            ? "Add"
                            : "Edit"
                          : "Add"}
                      </span>
                    </p>
                    <p className="sub-heading ">
                      {bookingDetails
                        ? bookingDetails?.insurance_company === "null" ||
                          !bookingDetails?.insurance_company
                          ? "NA"
                          : bookingDetails?.insurance_company
                        : ""}
                    </p>
                    <div>
                      <span className="sub-heading sm-d-block">
                        <p className="text-para d-inline">Policy No: </p>
                        {bookingDetails
                          ? bookingDetails?.insurance_no === "null" ||
                            !bookingDetails?.insurance_no
                            ? "NA"
                            : bookingDetails?.insurance_no
                          : ""}
                      </span>
                      <span className="sub-heading pt-lg-4">
                        <p className="text-para">Transit Insurance Details:</p>
                        {transitDetails && transitDetails ? (
                          <>
                            <BiSolidCheckCircle
                              className="green"
                              style={{ width: "14px" }}
                            />
                            <span className="sub-heading green d-inline">
                              Yes
                            </span>
                          </>
                        ) : (
                          "No"
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="booking-inline-row border-none uploadDiv">
                  <div className="col col-md-7 col-12 p-right">
                    <p className="text-para">
                      You are required to upload all the supporting documents on
                      or before your pickup date
                    </p>
                  </div>
                  <div className="col col-md-5 col-12 uploadBtn p-left">
                    {bookingDetails?.bookingid ? (
                      <button
                        onClick={() => {
                          navigate(
                            `/kyc-documents/${
                              bookingDetails?.bookingid ||
                              bookingStatus?.enqno ||
                              ""
                            }`
                          );
                        }}
                        className="upload-btn"
                      >
                        Upload Documents
                      </button>
                    ) : (
                      <button className="upload-btn" disabled>
                        Upload Documents
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div className="bookingDiv mt-4">
                {pickupCondition?.verify_status ? (
                  <div className="booking-inline-row border-none view-report align-items">
                    <div className="col col-8 reportRow">
                      <img
                        src={carReportimage}
                        alt="car-condition"
                        loading="eager"
                        width={80}
                        height={68}
                      />
                      <p className="sub-heading f-20 fw-semibold">
                        Your car condition report is ready.
                      </p>
                    </div>
                    <div className="col col-4 text-end">
                      <p className="text-para text-center mb-2">
                        View Car Report
                      </p>
                      <div className="carReportBtnDiv">
                        <button
                          className="view-repord f-15 mb-2"
                          onClick={() => setCondtionModel(true)}
                        >
                          Pickup
                        </button>
                        <button
                          className="view-repord f-15 mb-2"
                          onClick={() => setDeliveryCondtionModel(true)}
                        >
                          Delivery
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="booking-inline-row border-none view-report align-items">
                    <div className="col col-8 reportRow">
                      <img
                        src={carReportimage}
                        alt="car-condition"
                        loading="eager"
                        width={80}
                        height={68}
                      />
                      <p className="sub-heading f-20 fw-semibold disabled">
                        Your car condition report is pending.{" "}
                      </p>
                    </div>
                    <div className="col col-4 text-end">
                      <button disabled className="view-repord f-15">
                        View list
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <div className="bookingDiv mt-4">
                <div className="booking-inline-row border-none d-block">
                  <p className="sub-heading f-20 fw-semibold mb-2">
                    Track Booking
                  </p>
                  {bookingDetails?.pickuplocation &&
                  bookingDetails?.deliverylocation ? (
                    <div className="hide-scrollbar pt-2 heightTrackBookContent">
                      {trackData.length > 0 ? (
                        trackData.map((item) => (
                          <div className="track-img mt-5" key={item.id}>
                            <BiSolidCheckCircle style={{ color: "#0FA958" }} />
                            <span className="sub-heading">
                              {firstLetterUpperCase(item.comments)}
                              <p className="text-para">
                                {formatDateTime(item.created_at)}
                              </p>
                            </span>
                          </div>
                        ))
                      ) : (
                        <div className="h-100 trackBookDivNoData d-flex justify-content-center align-items-center">
                          <p>No Data</p>
                        </div>
                      )}
                      {/* <div className="track-img mt-5">
                        <BiSolidCheckCircle style={{ color: "#D3D3D3" }} />
                        <span className="sub-heading">
                          PICKUP FROM DELHI HUB
                          <p className="text-para">2nd Mar 2024</p>
                        </span>
                      </div> */}
                    </div>
                  ) : (
                    <p className="text-para mt-3">
                      Tracking will be available only after the pickup process
                      is completed.
                    </p>
                  )}
                </div>
              </div>
              {/* <div className="bookingDiv mt-4 pb-5">
                                                <div className="booking-inline-row border-none d-block">
                                                    <p className='sub-heading f-20 fw-semibold'>Delivery Details</p>
                                                    {bookingDetails?.pickuplocation && bookingDetails?.deliverylocation ?
                                                        <div className="delivery-details mt-3">
                                                            <span className='sub-heading'>
                                                                <p className='text-para'>Delivery Date & Time</p>
                                                                <BiCalendarAlt style={{ width: '16px', height: '16px', color: '#D7000C', marginRight: '7px' }} />
                                                                9th Mar 2024 13:40
                                                            </span>
                                                            <button className='reschedule-btn green' onClick={() => {
                                                                setPayModal(true)
                                                                setFrondPage(false)
                                                            }}>Reschedule</button>
                                                        </div>
                                                        :
                                                        <div className="delivery-details mt-3">
                                                            <span className='sub-heading'>
                                                                <p className='text-para'>Not Available</p>
                                                            </span>
                                                            <button className='reschedule-btn green' onClick={() => {
                                                                // setPayModal(true)
                                                                // setFrondPage(false)
                                                            }}>Schedule Delivery</button>
                                                        </div>
                                                    }
                                                </div>
                                            </div> */}
            </div>
            {/* --------Right col------- */}

            <div className="col col-md-4 col-lg-4 p-0">
              <div className="bookingDiv border-left-right">
                <div className="box">
                  <p className="sub-heading">
                    Booking Details
                    <span className="text-para black">
                      #{bookingDetails?.bookingid || bookingStatus?.enqno}
                    </span>
                    {/* <span className='text-para black booking-icons'>
                                                            <img src={car} alt="caricon" width={35} height={14} loading="eager" />
                                                            STANDARD</span> */}
                  </p>
                </div>
                <div className="box-flex">
                  <div className="div">
                    <p className="sub-heading f-15 text-center d-inline-block">
                      <span className="text-span black Moulpali">
                        {bookingDetails ? (
                          bookingDetails?.carno === "null" ||
                          !bookingDetails?.carno ? (
                            <>
                              <span className="carno-firstline">**</span>
                              <br />
                              ****
                            </>
                          ) : (
                            <>
                              <span className="carno-firstline">
                                {bookingDetails.carno
                                  .replace(/\s/g, "")
                                  .slice(0, 4)}
                              </span>
                              <br />
                              {bookingDetails.carno.replace(/\s/g, "").slice(4)}
                            </>
                          )
                        ) : (
                          "NA"
                        )}
                      </span>
                    </p>
                  </div>

                  <button
                    className="text-span link-btn"
                    onClick={() => setBookingLocation(true)}
                  >
                    {bookingDetails
                      ? bookingDetails?.pickuplocation_latlon === "null" ||
                        !bookingDetails?.pickuplocation_latlon ||
                        !bookingDetails?.deliverylocation_latlon ||
                        bookingDetails?.deliverylocation_latlon === "null"
                        ? "Add"
                        : "Edit"
                      : ""}
                  </button>
                </div>
                <div className="box-flex dots">
                  <p className="text-para black">
                    <BiMap className="red" />
                    {/* {bookingDetails ? (bookingDetails?.pickuplocation === "null" || !bookingDetails?.pickuplocation ? 'NA' : truncateText(bookingDetails?.pickuplocation, 20)) : ''} */}
                    <TruncatedView
                      text={bookingStatus?.pickuplocation || ""}
                      maxLength={20}
                      // placeholder="NA"
                    />
                  </p>
                  <button
                    className={`text-para ${
                      bookingDetails?.pickuplocation_latlon &&
                      bookingDetails.pickuplocation_latlon !== "null"
                        ? "fw-semibold black"
                        : ""
                    }`}
                    onClick={() => {
                      if (
                        bookingDetails?.pickuplocation_latlon &&
                        bookingDetails.pickuplocation_latlon !== "null"
                      ) {
                        const [lat, lng] =
                          bookingDetails.pickuplocation_latlon.split(",");
                        const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
                        window.open(googleMapsUrl, "_blank"); // Open the URL in a new tab
                      } else {
                        console.error(
                          "Pickup location is not available or invalid."
                        );
                      }
                    }}
                  >
                    {bookingDetails &&
                    (bookingDetails.pickuplocation_latlon === "null" ||
                      !bookingDetails.pickuplocation_latlon) ? (
                      <IoWarningOutline className="red danger" />
                    ) : (
                      ""
                    )}
                    Pickup Map Location
                  </button>
                </div>
                <div className="box-flex">
                  <p className="text-para black">
                    <BiMap />
                    {/* {bookingDetails ? (bookingDetails?.deliverylocation === "null" || !bookingDetails?.deliverylocation ? 'NA' : truncateText(bookingDetails?.deliverylocation, 20)) : ''} */}
                    <TruncatedView
                      text={bookingStatus?.deliverylocation || ""}
                      maxLength={20}
                      // placeholder="NA"
                    />
                  </p>
                  <button
                    className={`text-para ${
                      bookingDetails?.deliverylocation_latlon &&
                      bookingDetails.deliverylocation_latlon !== "null"
                        ? "fw-semibold black"
                        : ""
                    }`}
                    onClick={() => {
                      if (
                        bookingDetails?.deliverylocation_latlon &&
                        bookingDetails.deliverylocation_latlon !== "null"
                      ) {
                        const [lat, lng] =
                          bookingDetails.deliverylocation_latlon.split(",");
                        const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
                        window.open(googleMapsUrl, "_blank"); // Open the URL in a new tab
                      } else {
                        console.error(
                          "Delivery location is not available or invalid."
                        );
                      }
                    }}
                  >
                    {bookingDetails &&
                    (bookingDetails.deliverylocation_latlon === "null" ||
                      !bookingDetails.deliverylocation_latlon) ? (
                      <IoWarningOutline className="red danger" />
                    ) : (
                      ""
                    )}
                    Delivery Map Location
                  </button>
                </div>
                {bookingDetails?.pickuptime ? (
                  <div className="box-flex">
                    <span className="sub-heading">
                      <p className="text-para">Pickup Date & Time</p>
                      <BiCalendarAlt
                        style={{
                          width: "16px",
                          height: "16px",
                          color: "#D7000C",
                          marginRight: "7px",
                        }}
                      />
                      {bookingDetails
                        ? bookingDetails?.pickuptime === "null" ||
                          !bookingDetails?.pickuptime
                          ? "NA"
                          : bookingDetails?.pickuptime
                        : ""}
                    </span>
                    {/* <Link to="/" className='reschedule-btn red'>Reschedule</Link> */}
                  </div>
                ) : (
                  <div className="box-flex">
                    <span className="sub-heading">
                      <p className="text-para">Pickup Date & Time</p>
                      <BiCalendarAlt
                        style={{
                          width: "16px",
                          height: "16px",
                          color: "#D7000C",
                          marginRight: "7px",
                        }}
                      />
                      -/-
                    </span>
                    {/* <Link to="#" className='reschedule-btn red'>Schedule</Link> */}
                  </div>
                )}
              </div>
              <div className="bookingDiv total-amout">
                <div className="box-flex p-0">
                  <p className="text-para">{amountLabel}</p>
                  <p className="sub-heading">
                    {amountValue > 0 ? <> &#x20b9; {amountValue}</> : "-"}{" "}
                    <br />
                  </p>
                </div>
                <div className="box-flex p-0">
                  <p className="text-para">Paid</p>
                  <p className="sub-heading">
                    {paid > 0 ? <> &#x20b9; {paid} </> : "-"} <br />
                  </p>
                </div>
                <div className="box-flex p-0">
                  <p className="sub-heading">Balance</p>
                  {balance > 0 ? (
                    <p className="sub-heading f-20 amount">
                      <> &#x20b9; {balance} </> <br />
                    </p>
                  ) : (
                    <>
                      {isPayDisabled && invoiceExists && (
                        <p className="text-span span">No due</p>
                      )}
                    </>
                  )}
                </div>

                {invoiceExists && balance > 0 && (
                  <p className="text-span span">Inclusive of all taxes</p>
                )}
                {quoteStatus?.quote === 0 && (
                  <p className="text-span span">Quote not prepared</p>
                )}
                {!invoiceExists && quoteStatus?.quote !== 0 && (
                  <p className="text-span span text-start">
                    The final amount may be subject to change after the invoice
                    is created.
                  </p>
                )}
                {/* {isPayDisabled && invoiceExists && (
                  <p className="text-span span">No due</p>
                )} */}
              </div>
              <div
                className={`pay-now pay-now-btn ${
                  isPayDisabled ? "disabled-bg" : ""
                }`}
                onClick={() => {
                  if (!isPayDisabled) {
                    const bookingId =
                      quoteStatus?.bookingid || bookingStatus?.enqno || "";
                    if (bookingId) {
                      navigate(`/payment/${bookingId}`);
                    }
                  }
                }}
              >
                {isPayDisabled && invoiceExists ? "No due" : "Pay Now"}
              </div>
              <div className="bookingDiv border-radius">
                <div className="box-flex p-0 justify-content-center">
                  <p
                    className="text-span link-btn"
                    onClick={() => setAmountHistory(true)}
                  >
                    Payment History
                  </p>
                </div>
              </div>

              <div className="bookingDiv mt-4">
                <div className="box-flex p-0">
                  <div className="col">
                    <img
                      src={customerSupportImage}
                      className="customer-support-img"
                      alt="customer-subport"
                      width={84}
                      height={84}
                      loading="eager"
                    />
                  </div>
                  <div className="col col-8">
                    <p className="sub-heading f-20 fw-semibold">
                      Looking for help?
                    </p>
                    <p className="text-para">
                      We are available all working days. <br /> You can call us
                      at
                    </p>
                    <p className="sub-heading"> 044-26211718 / 26211819</p>
                    <p className="sub-heading">044-26208376 / 26208377</p>
                  </div>
                </div>
              </div>
              <div className="bookingDiv mt-4">
                <div className="box-flex p-0 d-block text-center">
                  <div>
                    <img
                      src={carGiftImg}
                      alt="cargift"
                      width={108}
                      height={108}
                      loading="eager"
                    />
                    <p className="sub-heading mb-1 f-20 fw-semibold">
                      Happy Faces <br /> from our customers
                    </p>
                    <p className="text-para pb-2 d-xxl-none">
                      Happy customers, happy us! <br /> Read their testimonials
                      and join <br /> the ranks of satisfied smiles
                    </p>
                    <p className="text-para d-none d-xxl-block">
                      Happy customers, happy us! Read their testimonials and
                      join the ranks of satisfied smiles
                    </p>

                    <div className="slider-container pb-1">
                      {images.map((image, index) => {
                        let positionClass = "image-left"; // Default left position

                        if (index === (currentIndex + 1) % images.length) {
                          positionClass = "image-right"; // Right-side image
                        }
                        if (index === currentIndex) {
                          positionClass = "image-center"; // Center large image
                        }
                        return (
                          <img
                            key={index}
                            src={image}
                            alt={`Symbolizes delivery inspection and service excellence ${
                              index + 1
                            }`}
                            className={`slider-image ${positionClass}`}
                          />
                        );
                      })}
                    </div>
                    {/* <p><button to="#" className='upload-btn bg-blue'>Add your review</button></p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Home;
